import React, { useState, useEffect } from 'react';
import ModuleTemplate from '../../ModuleTemplate';
import { useSpeakAnswer } from '../../lib/useSpeakAnswer';
import { fallbackWrongKey } from '../../lib/speechAnswerEvaluator';
import { useInstructionAudio } from '../../lib/useInstructionAudio';
import './DaysOfWeek.css';

/* eslint-disable react-hooks/exhaustive-deps */

const S3_BASE_URL = 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/awareness';

// Ключи дней недели
const DAYS_OF_WEEK = [
  { key: 'mon' }, { key: 'tue' }, { key: 'wed' }, { key: 'thu' }, { key: 'fri' }, { key: 'sat' }, { key: 'sun' }
];

// Названия дней для распознавания речи в режиме "Говорить"
const DAY_NAMES = {
  mon: 'Понедельник', tue: 'Вторник', wed: 'Среда', thu: 'Четверг',
  fri: 'Пятница', sat: 'Суббота', sun: 'Воскресенье',
};
const DAY_CANDIDATES = DAYS_OF_WEEK.map(day => ({ key: day.key, text: DAY_NAMES[day.key] }));

// Генерируем сетку календаря 6х7 (42 ячейки: 1 ряд для шапки Пн-Вс + 5 рядов для чисел)
const CALENDAR_DAYS = [];
for (let week = 0; week < 6; week++) {
  DAYS_OF_WEEK.forEach(day => {
    CALENDAR_DAYS.push({ ...day, cellId: `${day.key}-${week}` });
  });
}

const TASKS_BY_AGE = {
  '4': [
    { id: 1, question: 'Сегодня среда, какой день недели завтра?', correctKey: 'thu', correctText: 'Четверг' },
    { id: 2, question: 'Завтра четверг, а что сегодня?', correctKey: 'wed', correctText: 'Среда' },
    { id: 4, question: 'Вчера была суббота. Какой сегодня день?', correctKey: 'sun', correctText: 'Воскресенье' },
    { id: 3, question: 'Позавчера был понедельник. Какой сегодня день?', correctKey: 'wed', correctText: 'Среда' },
    { id: 4, question: 'Послезавтра будет четверг. Какой сегодня день?', correctKey: 'tue', correctText: 'Вторник' },
  ],
  '5': [
     { id: 1, question: 'Сегодня среда, какой день недели завтра?', correctKey: 'thu', correctText: 'Четверг' },
    { id: 2, question: 'Завтра четверг, а что сегодня?', correctKey: 'wed', correctText: 'Среда' },
    { id: 4, question: 'Вчера была суббота. Какой сегодня день?', correctKey: 'sun', correctText: 'Воскресенье' },
    { id: 3, question: 'Позавчера был понедельник. Какой сегодня день?', correctKey: 'wed', correctText: 'Среда' },
    { id: 4, question: 'Послезавтра будет четверг. Какой сегодня день?', correctKey: 'tue', correctText: 'Вторник' },
  ],
  '6': [
    { id: 1, question: 'Сегодня среда, какой день недели завтра?', correctKey: 'thu', correctText: 'Четверг' },
    { id: 2, question: 'Завтра четверг, а что сегодня?', correctKey: 'wed', correctText: 'Среда' },
    { id: 4, question: 'Вчера была суббота. Какой сегодня день?', correctKey: 'sun', correctText: 'Воскресенье' },
    { id: 3, question: 'Позавчера был понедельник. Какой сегодня день?', correctKey: 'wed', correctText: 'Среда' },
    { id: 4, question: 'Послезавтра будет четверг. Какой сегодня день?', correctKey: 'tue', correctText: 'Вторник' },
  ], 
  '7-9': [
     { id: 1, question: 'Сегодня среда, какой день недели завтра?', correctKey: 'thu', correctText: 'Четверг' },
    { id: 2, question: 'Завтра четверг, а что сегодня?', correctKey: 'wed', correctText: 'Среда' },
    { id: 4, question: 'Вчера была суббота. Какой сегодня день?', correctKey: 'sun', correctText: 'Воскресенье' },
    { id: 3, question: 'Позавчера был понедельник. Какой сегодня день?', correctKey: 'wed', correctText: 'Среда' },
    { id: 4, question: 'Послезавтра будет четверг. Какой сегодня день?', correctKey: 'tue', correctText: 'Вторник' },
  ],
  '10-12': [
     { id: 1, question: 'Сегодня среда, какой день недели завтра?', correctKey: 'thu', correctText: 'Четверг' },
    { id: 2, question: 'Завтра четверг, а что сегодня?', correctKey: 'wed', correctText: 'Среда' },
    { id: 4, question: 'Вчера была суббота. Какой сегодня день?', correctKey: 'sun', correctText: 'Воскресенье' },
    { id: 3, question: 'Позавчера был понедельник. Какой сегодня день?', correctKey: 'wed', correctText: 'Среда' },
    { id: 4, question: 'Послезавтра будет четверг. Какой сегодня день?', correctKey: 'tue', correctText: 'Вторник' },
  ]
};

const DaysOfWeek = ({ ageGroup, onBack, onStartPause, onComplete }) => {
  const { start: startSpeakRecognition } = useSpeakAnswer('DaysOfWeek');
  const { play: playInstruction, stop: stopInstruction } = useInstructionAudio();

  const [selectedMode, setSelectedMode] = useState(null);
  const [blinkTarget, setBlinkTarget] = useState('speak');

  const [isListening, setIsListening] = useState(false);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [hasSpoken, setHasSpoken] = useState(false);
  const [recognizerReady, setRecognizerReady] = useState(false);

  const [currentTaskIndex, setCurrentTaskIndex] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [answerLog, setAnswerLog] = useState([]);
  const [showResult, setShowResult] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  
  const [clickedCell, setClickedCell] = useState(null);

  const tasks = TASKS_BY_AGE[ageGroup] || TASKS_BY_AGE['4'];
  const currentTask = tasks[currentTaskIndex];
  const totalQuestions = tasks.length;

  useEffect(() => {
    if (selectedMode) return;
    const interval = setInterval(() => {
      setBlinkTarget(prev => (prev === 'speak' ? 'show' : 'speak'));
    }, 700);
    return () => clearInterval(interval);
  }, [selectedMode]);

  useEffect(() => {
    if (currentTask && !hasSpoken && selectedMode && !showResult) {
      setHasSpoken(true);
      setIsListening(true);
      setIsSpeaking(false);
      setRecognizerReady(false);
      setClickedCell(null);

      playInstruction(currentTask.question, () => {
        setIsListening(false);
        setIsSpeaking(true);
      });
    }
  }, [currentTaskIndex, selectedMode, showResult]);

  // Режим "Говорить": слушаем ребёнка через распознаватель речи и сравниваем
  // сказанное с названием правильного дня недели.
  useEffect(() => {
    if (isSpeaking && !isProcessing && selectedMode === 'speak' && currentTask) {
      setIsProcessing(true);
      startSpeakRecognition(DAY_CANDIDATES, {
        onListening: () => setRecognizerReady(true),
        onResult: ({ matchedKey }) => {
          const dayKey = matchedKey || fallbackWrongKey(DAY_CANDIDATES, currentTask.correctKey);
          handleDayClick(dayKey, `${dayKey}-0`);
        },
      });
    }
  }, [isSpeaking, selectedMode, currentTask]);

  const handleDayClick = (dayKey, cellId) => {
    if (!isSpeaking || isProcessing) return;
    setIsProcessing(true);
    stopInstruction();

    const isCorrect = currentTask.correctKey === dayKey;
    
    setAnswers(prev => [...prev, isCorrect]);
    setAnswerLog(prev => [...prev, { taskId: currentTask.id, selectedDay: dayKey, correct: isCorrect }]);
    setClickedCell({ cellId, correct: isCorrect });

    setTimeout(() => {
      setIsProcessing(false);
      setClickedCell(null);
      if (currentTaskIndex + 1 < totalQuestions) {
        setCurrentTaskIndex(prev => prev + 1);
        setHasSpoken(false);
      } else {
        setShowResult(true);
      }
    }, 1000);
  };

  useEffect(() => {
    if (showResult) {
      const timer = setTimeout(() => {
        const correctCount = answers.filter(a => a === true).length;
        const score = Math.round((correctCount / totalQuestions) * 100);
        if (onComplete) {
          onComplete({
            testId: 'DaysOfWeek',
            score,
            details: { total: totalQuestions, correct: correctCount, mode: selectedMode, log: answerLog }
          });
        } else {
          onBack();
        }
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [showResult]);

  if (showResult) {
    const correctCount = answers.filter(a => a === true).length;
    return (
      <ModuleTemplate progress={answers} totalQuestions={totalQuestions}   forceStop={true}
      onComplete={onComplete || onBack}>
        <div className="result-content">
          <h2 className="result-title">🎉 Упражнение завершено!</h2>
          <div className="result-score">
            <span className="score-number">{correctCount}</span>
            <span className="score-total"> / {totalQuestions}</span>
          </div>
        </div>
      </ModuleTemplate>
    );
  }

  if (!currentTask) return (
    <ModuleTemplate progress={answers} totalQuestions={totalQuestions}   forceStop={true}
      onComplete={onComplete || onBack}>
      <div className="loading-text">Выберите режим ниже, чтобы начать</div>
    </ModuleTemplate>
  );

    return (
    <ModuleTemplate
      progress={answers}
      totalQuestions={totalQuestions}
      forceStop={true}
      onComplete={onComplete || onBack}
      
    >
      <div className="days-container">

        {!selectedMode && (
          <div className="mode-buttons">
            <button onClick={() => setSelectedMode('speak')} className={`mode-btn ${blinkTarget === 'speak' ? 'active' : ''}`}>🎙️ Говорить</button>
            <button onClick={() => setSelectedMode('show')} className={`mode-btn ${blinkTarget === 'show' ? 'active' : ''}`}>👆 Показать</button>
          </div>
        )}

        <div className="days-main-area">
          <div className="days-board-wrapper">
            <div className="days-grid">
              {CALENDAR_DAYS.map((day) => {
                const isCorrect = clickedCell?.cellId === day.cellId && clickedCell?.correct;
                const isWrong = clickedCell?.cellId === day.cellId && !clickedCell?.correct;
                
                return (
                  <div 
                    key={day.cellId} 
                    className={`day-cell ${isCorrect ? 'cell-correct' : ''} ${isWrong ? 'cell-wrong' : ''} ${!clickedCell && isSpeaking ? 'cell-active' : ''}`}
                    onClick={() => handleDayClick(day.key, day.cellId)}
                  >
                    {/* Текст убран, ячейки пустые и прозрачные */}
                  </div>
                );
              })}
            </div>
          </div>

          <div className="days-indicators">
            <div className={`indicator listen ${isListening ? 'active' : ''}`}><span className="indicator-icon">🎧</span></div>
            <div className={`indicator speak ${isSpeaking && (selectedMode !== 'speak' || recognizerReady) ? 'active' : ''}`}><span className="indicator-icon">🗣️</span></div>
          </div>
        </div>

      </div>
    </ModuleTemplate>
  );
};

export default DaysOfWeek;